var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',[_vm._v(" "+_vm._s(_vm.fileIcons[String(_vm.item.filetype || "").toLowerCase()] || _vm.fileIcons.other)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }